import blue from './blue.png';
import green from './green.png';
import orange from './orange.png';
import purple from './purple.png';
import red from './red.png';
import gold from './gold.png';

export default { blue, green, orange, purple, red, gold };
